export const API_KEY_ACCESS_LEVEL = Object.freeze({
  READ_ONLY: 'read_only',
  RUN_WORKFLOWS: 'run_workflows',
  FULL_ACCESS: 'full_access'
});

export const API_KEY_ACCESS_LEVELS = Object.freeze(Object.values(API_KEY_ACCESS_LEVEL));

export const API_KEY_ACCESS_LEVEL_LABEL = Object.freeze({
  [API_KEY_ACCESS_LEVEL.READ_ONLY]: 'Read-only',
  [API_KEY_ACCESS_LEVEL.RUN_WORKFLOWS]: 'Run workflows',
  [API_KEY_ACCESS_LEVEL.FULL_ACCESS]: 'Full access'
});

const accessRank = Object.freeze({
  [API_KEY_ACCESS_LEVEL.READ_ONLY]: 0,
  [API_KEY_ACCESS_LEVEL.RUN_WORKFLOWS]: 1,
  [API_KEY_ACCESS_LEVEL.FULL_ACCESS]: 2
});

export const hasApiKeyAccess = ({ accessLevel, requiredAccessLevel }) => {
  return accessRank[accessLevel] != null && accessRank[requiredAccessLevel] != null && accessRank[accessLevel] >= accessRank[requiredAccessLevel];
};
